module.exports = __webpack_public_path__ + "7f1320f7ec4f6716054d88c33235d17b.ttf";